import React from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';

const formatContentForDisplay = (content) => {
  if (content === null || content === undefined) {
    return <span className="text-gray-400 italic">null</span>;
  }
  if (typeof content === 'object') {
    return <pre className="text-sm whitespace-pre">{JSON.stringify(content, null, 2)}</pre>;
  }
  return <pre className="text-sm whitespace-pre-wrap break-words">{String(content)}</pre>;
};

export default function SideBySideDiffViewer({ data, onClose }) {
  if (!data) return null;

  return (
    <div
      className="bg-white rounded-lg shadow-xl w-full min-h-[300px] max-w-4xl overflow-y-scroll max-h-[90vh] flex flex-col"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-lg font-semibold">
          Side-by-Side Diff: <span className="font-mono bg-gray-100 p-1 rounded">{data.fieldName}</span>
        </h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
          <IoMdCloseCircleOutline size={24} />
        </button>
      </div>

      <div className="grid grid-cols-2 h-full gap-4 p-4 ">
        <div className="min-w-0">
          <h3 className="text-md font-bold mb-2 text-red-600">From</h3>
          <div className="bg-red-50 p-3 rounded-md border border-red-200 h-full overflow-auto">
            {formatContentForDisplay(data.fromValue)}
          </div>
        </div>

        <div className="min-w-0">
          <h3 className="text-md font-bold mb-2 text-green-600">To</h3>
          <div className="bg-green-50 p-3 rounded-md border border-green-200 h-full overflow-auto">
            {formatContentForDisplay(data.toValue)}
          </div>
        </div>
      </div>
    </div>
  );
}